import { render, staticRenderFns } from "./Family-statement-notification-assignment-table.vue?vue&type=template&id=5d8a54ea"
import script from "./Family-statement-notification-assignment-table.vue?vue&type=script&lang=js"
export * from "./Family-statement-notification-assignment-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports